import { render, staticRenderFns } from "./SectionSearch.vue?vue&type=template&id=1ed3e834&scoped=true"
import script from "./SectionSearch.vue?vue&type=script&lang=js"
export * from "./SectionSearch.vue?vue&type=script&lang=js"
import style0 from "./SectionSearch.vue?vue&type=style&index=0&id=1ed3e834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed3e834",
  null
  
)

export default component.exports